"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTreeNodePaths = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const client_utils_1 = require("../../client.utils");
const get_tree_nodes_utils_1 = require("../get-tree-nodes.utils");
const gql_1 = require("../gql");
const useTreeNodePaths = () => {
    const [getTreeNodesQuery, _a] = (0, react_2.useLazyQuery)(gql_1.GET_PRODUCT_TREE_NODE_PATHS, { notifyOnNetworkStatusChange: true }), { data } = _a, queryResponse = __rest(_a, ["data"]);
    const getTreeNodePaths = (0, react_1.useCallback)((options) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        const response = yield getTreeNodesQuery(options);
        (0, client_utils_1.genericGraphQLErrorsHandler)(response);
        return Object.assign(Object.assign({}, response), { data: (0, get_tree_nodes_utils_1.getTreeNodePaths)(((_d = (_c = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.productTreeNodes) === null || _b === void 0 ? void 0 : _b.edges) === null || _c === void 0 ? void 0 : _c.map((item) => item.node)) !== null && _d !== void 0 ? _d : [])) });
    }), [getTreeNodesQuery]);
    return Object.assign({ getTreeNodePaths }, queryResponse);
};
exports.useTreeNodePaths = useTreeNodePaths;
exports.default = exports.useTreeNodePaths;
